import React from 'react'
import { Button, Container, List } from 'semantic-ui-react'

import AuthenticationShell from 'shared/components/AuthenticationShell'

import './styles.css'

export interface ConfirmScreenProps {
  email: string
  isConnecting: boolean
  onContinue: () => void
  onSwitchAccount: () => void
}

export default function ConfirmScreen({
  email,
  isConnecting,
  onContinue,
  onSwitchAccount,
}: ConfirmScreenProps) {
  return (
    <AuthenticationShell
      headerText="Connect to Simplesat"
      subHeaderText={
        <span className="inline-block max-w-full break-words">
          You&apos;re signed in as <strong>{email}</strong>
          <br />
          Continue to choose a workspace and allow access.
        </span>
      }
    >
      <Button
        primary
        fluid
        size="large"
        type="button"
        loading={isConnecting}
        disabled={isConnecting}
        onClick={onContinue}
      >
        Continue
      </Button>
      <List>
        <List.Item>
          <Container textAlign="center">
            <a
              href="#switch-account"
              className={isConnecting ? 'ss-oauth-connect-link-disabled' : undefined}
              aria-disabled={isConnecting}
              onClick={(event) => {
                event.preventDefault()
                onSwitchAccount()
              }}
            >
              Use a different account
            </a>
          </Container>
        </List.Item>
      </List>
    </AuthenticationShell>
  )
}



// WEBPACK FOOTER //
// ./src/pages/OAuthConnect/ConfirmScreen.tsx